import { createConfig } from '@wagmi/core'
import { polygon, polygonAmoy } from '@wagmi/core/chains'
import { environment } from 'src/environments/environment'
import { rpcTransport } from './rpc-transport'

const supported_chains: any = environment.SUPPORTED_CHAINS[0] == '137' ? polygon : polygonAmoy

export const wagmi_config = createConfig({
    chains: [supported_chains],
    transports: {
        [supported_chains?.id]: rpcTransport()
    },
});